import OnDemandDevelopers from "../on-demand-developers";
import ProjectByEquity from "../project-by-equity";
import FullProjectDevelopment from "../full-project-development";
import WhatServices from "../what-services";
import Confirmation from "../confirmation";
import NavBar from "../nav-bar";
import Intro from "../Intro";
import OurServices from "../our-services";
import SeeOurWork from "../see-our-work";
import ImpactAcrossIndustries from "../impact-across-industries";
import WhatMakeUsDifferent from "../what-make-us-different";
import WhatOurClientSays from "../what-our-client-says";
import MeetOurTeam from "../meet-our-team";
import AboutUs from "../about-us";
import Grid from "@mui/material/Grid/Grid";
import {CustomLabelMediumBold, CustomLabelMediumRegular} from "../common/CustomLabel";
import Box from "@mui/material/Box/Box";
import IPHONE151 from "../../assets/images/iPhone 15 Pro-1.png";
import ContactUs from "../contact-us";
import Footer from "../footer";
import React, {useRef, useState} from "react";
import {useMediaQuery} from "@mui/material";
import createTheme from "@mui/material/styles/createTheme";
import IntroDetails from "../intro-details";
import WorkDetails from "../work-details";
import PROJECT1 from "../../assets/images/project_1.png";
import PROJECT2 from "../../assets/images/project2.png";
import PROJECT3 from "../../assets/images/project3.png";

import { useSearchParams } from 'react-router-dom';

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 710,
            md: 950,
            lg: 1300,
            xl: 1350,
        },
    },
});


// Carousel settings for react-slick
var settings_our_work = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: true,
    responsive: [

        {
            breakpoint: 1300, // Large screens
            settings: {
                slidesToShow: 2.5,
            },
        },

        {
            breakpoint: 1200, // Large screens
            settings: {
                slidesToShow: 2.5,
            },
        },
        {
            breakpoint: 1024, // Large screens
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 700, // Large screens
            settings: {
                slidesToShow: 1.5,
            },
        },
        {
            breakpoint: 480, // Mobile
            settings: {
                slidesToShow: 1.2,
            },
        },
    ],
};


// Carousel settings for react-slick
var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 1024, // Large screens
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480, // Mobile
            settings: {
                slidesToShow: 1.2,
            },
        },
    ],
};


// Carousel settings for react-slick
var profile_carousel_settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 1400, // Large screens
            settings: {
                slidesToShow: 3.5,
            },
        },
        {
            breakpoint: 1200, // Large screens
            settings: {
                slidesToShow: 2.5,
            },
        },
        {
            breakpoint: 1024, // Large screens
            settings: {
                slidesToShow: 2.5,
            },
        },
        {
            breakpoint: 680, // Mobile
            settings: {
                slidesToShow: 1.5,
            },
        },
    ],
};


const OurWork = ({}) => {

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


    const [searchParams] = useSearchParams();


    const [showFullProject, setShowFullProject] = useState(false);
    const [showOnDemandDevelopers, setShowOnDemandDevelopers] = useState(false);
    const [showProjectByEquity, setShowProjectByEquity] = useState(false);
    const [showWhatServices, setShowWhatService] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);


    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const testimonalsRef = useRef(null);
    const partnersRef = useRef(null);
    const contactUsRef = useRef(null);


    let projects=[
        {
            img: PROJECT1,
            title: "EcoVibes Marketplace",
            description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
            tags: ["UI/UX Design", "Front-end Development", "Website"]
        },
        {
            img: PROJECT2,
            title: "HealthLink App",
            description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
            tags: ["UI/UX Design", "Front-end Development", "Website"]
        },
        {
            img: PROJECT3,
            title: "TechSavvy Education Portal",
            description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
            tags: ["UI/UX Design", "Front-end Development", "Website"]
        },
        {
            img: PROJECT1,
            title: "EcoVibes Marketplace",
            description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
            tags: ["UI/UX Design", "Front-end Development", "Website"]
        },
        {
            img: PROJECT2,
            title: "HealthLink App",
            description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
            tags: ["UI/UX Design", "Front-end Development", "Website"]
        },
        {
            img: PROJECT3,
            title: "TechSavvy Education Portal",
            description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
            tags: ["UI/UX Design", "Front-end Development", "Website"]
        }
    ];


    const DetailsList = {
        "UI/UX":{
            title: "UI/UX Design",
            description: "We create user-friendly interfaces and engaging experiences for your website or app, ensuring it's easy to navigate and leaves a lasting impression on your audience. Our meticulous attention to detail ensures that every aspect of the design enhances usability and reflects your brand identity.",
            work: projects
        },
        "SaaS":{
            title: "SaaS",
            description: "We create user-friendly interfaces and engaging experiences for your website or app, ensuring it's easy to navigate and leaves a lasting impression on your audience. Our meticulous attention to detail ensures that every aspect of the design enhances usability and reflects your brand identity.",
            work: projects
        },
        "Mobile App Development":{
            title: "Mobile App Development",
            description: "We create user-friendly interfaces and engaging experiences for your website or app, ensuring it's easy to navigate and leaves a lasting impression on your audience. Our meticulous attention to detail ensures that every aspect of the design enhances usability and reflects your brand identity.",
            work: projects
        },
        "Web App Development":{
            title: "Web App Development",
            description: "We create user-friendly interfaces and engaging experiences for your website or app, ensuring it's easy to navigate and leaves a lasting impression on your audience. Our meticulous attention to detail ensures that every aspect of the design enhances usability and reflects your brand identity.",
            work: projects
        },
        "Graphic Design":{
            title: "Graphic Design",
            description: "We create user-friendly interfaces and engaging experiences for your website or app, ensuring it's easy to navigate and leaves a lasting impression on your audience. Our meticulous attention to detail ensures that every aspect of the design enhances usability and reflects your brand identity.",
            work: projects
        },
        "Video Editing":{
            title: "Video Editing",
            description: "We create user-friendly interfaces and engaging experiences for your website or app, ensuring it's easy to navigate and leaves a lasting impression on your audience. Our meticulous attention to detail ensures that every aspect of the design enhances usability and reflects your brand identity.",
            work: projects
        },
        "default":{
            title: "Our Work Speaks for Itself",
            description: "We create user-friendly interfaces and engaging experiences for your website or app, ensuring it's easy to navigate and leaves a lasting impression on your audience. Our meticulous attention to detail ensures that every aspect of the design enhances usability and reflects your brand identity.",
            work: projects
        }

    }

    let query=searchParams.get("details")

    let selectedWork=DetailsList[query||"default"];


    return (
        <Grid style={{width: "100vw", height: "100vh", overflowX: "hidden",}}>

            {
                showOnDemandDevelopers && <OnDemandDevelopers setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                                              setShowConfirmation={setShowConfirmation}
                />
            }

            {
                showProjectByEquity && <ProjectByEquity setShowProjectByEquity={setShowProjectByEquity}
                                                        setShowConfirmation={setShowConfirmation}/>
            }


            {
                showFullProject && <FullProjectDevelopment setShowFullProject={setShowFullProject}
                                                           setShowConfirmation={setShowConfirmation}/>
            }


            {
                showWhatServices &&
                <WhatServices setShowWhatService={setShowWhatService} setShowFullProject={setShowFullProject}
                              setShowProjectByEquity={setShowProjectByEquity}
                              setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            }


            {
                showConfirmation && <Confirmation setShowConfirmation={setShowConfirmation}/>
            }

            <NavBar isMenuClicked={isMenuClicked} serviceRef={serviceRef} portfolioRef={portfolioRef}
                    testimonalsRef={testimonalsRef} partnersRef={partnersRef} setIsMenuClicked={setIsMenuClicked}
                    contactUsRef={contactUsRef}
                    setShowWhatService={setShowWhatService}/>


            <IntroDetails title={selectedWork.title}
                          description={selectedWork.description}
            />


            <Grid item xs={12} container
                  justifyContent={"center"}
                  sx={{
                      marginTop: {xs: "0px", md: "-10px"},
                      padding: {xs: '0px 0px', sm: "12px 0px", md: '12px 20px', lg: "12px 50px", xl: "12px 60px"}
                  }}>
                <Grid item xs={11} md={9.5}>
                    <WorkDetails {...selectedWork} type={2}/>
                </Grid>


            </Grid>
            <OurServices serviceRef={serviceRef} setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                         setShowWhatService={setShowWhatService}
                         setShowFullProject={setShowFullProject}
                         setShowProjectByEquity={setShowProjectByEquity}/>


            <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}}} justifyContent={"center"}>

                <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                    <CustomLabelMediumBold text={"Discuss Your Project with #1 Software Development Company USA "} color={"#5E17EB"}/>
                </Grid>

                <Grid item container xs={10} style={{marginTop: "5px"}} justifyContent={"center"}>
                    <CustomLabelMediumRegular normal={false}
                                              text={"Got an Idea? Let’s Build It Together — Contact Us for Expert Development Solutions.  "}
                    />
                </Grid>


                <Grid item container xs={12}  justifyContent={"space-between"}
                      sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "20px", lg: "60px"}}}>


                    <Grid item xs={12} lg={4.8}
                          sx={{maxHeight: "100%", width: "100%", padding: "0px", position: "relative"}}>
                        <Box component={"img"} src={IPHONE151} alt={"OSTRYX"}
                             sx={{height: {lg: "100%"}, width: {xs: "100%", lg: "100%", xlg: "auto"}}}/>
                    </Grid>

                    <ContactUs setShowConfirmation={setShowConfirmation}/>


                </Grid>

                <div ref={contactUsRef} tabIndex={0}></div>

            </Grid>


            <Footer/>

        </Grid>
    )
}

export default OurWork;
